module.exports = __webpack_public_path__ + "static/media/caravan.ba30938c.svg";